<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dKXqfl/tc-custom/9781488006739.jpg?1705002725835" alt="This image is the cover for the book Promise He Made Her, Where Secrets Are Safe"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Promise He Made Her, Where Secrets Are Safe
      </h1>
      <p class="bookDescription body article font2">
        <b>A man of his word </b><br/><br/>Dr. Bloom Freelander thought it was safe to breathe again when Detective Sam Larson put her abusive ex away for good. She's been moving on, running a private practice and providing psychiatry services to The Lemonade Stand women's shelter. But now that her ex is a free man, she's in danger once again. <br/><br/>Forced into protective custody, Bloom can't help but fall for her protector. But she has every reason to doubt the handsome detective's word. Sam broke his promise to her once. Who says he won't break it againalong with her heart this time?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tara Taylor Quinn
      </h2>
      
      <p class="authorDescription body article"> Tara Taylor Quinn, is a&#160;<I>USA Today</I>&ndash;bestselling author of one hundred novels, which have been translated into twenty languages and has sold more than seven million copies. Known for her intense emotional fiction, Quinn&rsquo;s novels have received critical acclaim, including the 2008 National Reader&rsquo;s Choice Award, and five RITA Award finalist, and a former president and board director of the Romance Writers of America. She has appeared often on local and national TV, including&#160;<I>CBS Sunday Morning</I>. For additional offers, news, and contests, visit the author at tarataylorquinn.com. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f5b54c0